import { textSerifTitle1 } from '../../styles/typography';
import { classNames } from '../../utils/style';
import Arrow from '../../assets/images/arrow_Popup_Player.svg';
import { DefaultBsComponent } from '../../types/module';
import React, { cloneElement } from 'react';

export interface VideoCtaProps extends DefaultBsComponent {
  ctaLightboxTitle?: string;
  ctaButtonLightbox?: any;
}

export const VideoCta = ({
  ctaLightboxTitle,
  ctaButtonLightbox,
}: VideoCtaProps) => {
  const newCtaButton =
    ctaButtonLightbox &&
    cloneElement(ctaButtonLightbox, {
      props: {
        ...ctaButtonLightbox?.props,
        className: classNames('mt-[37px] cursor-pointer'),
      },
    });
  return (
    <div className="VideoCta flex flex-col items-center mt-[60px]">
      <div
        className={classNames(
          textSerifTitle1,
          'text-28 tracking-[.3px] md:text-40 leading-[32px] text-center text-neutral-1',
        )}
      >
        {ctaLightboxTitle}
      </div>
      {newCtaButton && (
        <div className="relative flex justify-center text-neutral-1 mt-16">
          <Arrow className="absolute w-[64px] left-[-80px] h-full" />
          {newCtaButton}
        </div>
      )}
    </div>
  );
};
